var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.832 27.831a.567.567 0 01-.808 0l-6.856-6.923a.58.58 0 010-.816l6.856-6.923a.567.567 0 01.808 0 .58.58 0 010 .816L13.38 20.5l6.452 6.515a.58.58 0 010 .816z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 20c.276 0 .5.269.5.6 0 .295-.177.54-.41.59l-.09.01h-16c-.276 0-.5-.269-.5-.6 0-.295.177-.54.41-.59l.09-.01h16z"
  })));
}
export default SvgBack;